// Vendor imports
const { connect } = require('react-redux')
const { createSelector } = require('reselect')
// Shared imports
const BemEntity = require('shared/bem')
const { formatCount } = require('shared/string-utils')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const SimpleNav = require('client-v2/common/components/simple-nav')
// Container imports
const interestActions = require('../interest/actions')
// URL helpers
const {
  interestProfileFollowersHref,
  interestProfilePostsHref
} = interestActions

const bemEntity = BemEntity('InterestProfileNav')

function mapStateToProps() {
  const itemsSelector = createItemsSelector()
  return function (state) {
    return {
      bemEntity,
      itemsSelector,
      interest: state.interest,
      selectedItemId: selectedState(state)
    }
  }
}

const mapDispatchToProps = {
  onFollowersClick: interestActions.navigateToInterestProfileFollowers,
  onPostsClick: interestActions.navigateToInterestProfilePosts
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    items: stateProps.itemsSelector(stateProps, dispatchProps)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(
  withImmutableToJS(
    SimpleNav
  )
)

// State helpers

function createItemsSelector() {
  return createSelector(
    [
      (stateProps) => stateProps.interest,
      (stateProps, dispatchProps) => dispatchProps
    ],
    (interest, dispatchProps) => [
      {
        id: 'posts',
        label: 'Posts',
        href: interestProfilePostsHref(interest),
        onClick: event => dispatchProps.onPostsClick({ event, interest })
      },
      {
        id: 'followers',
        label: `Followers • ${formatCount(interest.followersCount)}`,
        href: interestProfileFollowersHref(interest),
        onClick: event => dispatchProps.onFollowersClick({ event, interest })
      }
    ]
  )
}

function selectedState(state) {
  switch (state.router.action) {
    case 'interest-profile.showFollowers':
      return 'followers'
    case 'interest-profile.showPosts':
      return 'posts'
    default:
      return null
  }
}
